import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useEditAddress = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "shipmentaddresscard",
        command: "edit",
        data: JSON.stringify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["shipmentaddresslist"] });
    },
  });
};
